'use client'

import React, { useEffect, useRef, useState } from 'react'
import Image from 'next/image'
import CatalogCategory from './catalog/CatalogCategory'
import slidePrevArrow from '@/assets/img/full-product/slide-prev.svg'
import slideNextArrow from '@/assets/img/full-product/slide-next.svg'
import { ArticlesCard, CategoriesSlide, MegaschoolCardType, UsefulMaterialsCard } from '@/types'
import UsefulMatCard from './useful-materials/UsefulMatCard'
import MegaschoolCard from './Megaschool/MegaschoolCard'
import OurArticlesCard from './OurArticlesCard'
import { ExternalLink } from '@/redux/services/externalLinksApi'
import { MegaschoolRelease } from '@/redux/services/megaschoolReleasesApi'
import { TypeOfAnimal } from '@/redux/services/catalogApi'
import MaterialsCategory from './useful-materials/MaterialsCategory'
import AssortmentCard from './trading/AssortmentCard'

type Props = {
    page: string
    list: CategoriesSlide[] | UsefulMaterialsCard[] | MegaschoolRelease[] | ExternalLink[] | TypeOfAnimal[] | any[],
    setHeader?: any
    type?: string
}

const CategoriesSlider: React.FC<Props> = ({ page, list, setHeader, type }) => {
    const [translate, setTranslate] = useState(0)
    const [screenWidth, setScreenWidth] = useState(1200)
    const [marginDifference, setMarginDifference] = useState(0)
    const sliderRef = useRef<HTMLUListElement>(null)
    const [startX, setStartX] = useState(0);
    const [dragDirection, setDragDirection] = useState(null);

    // useEffect(() => {
    //     const handleDragStart = (e) => {
    //         setStartX(e.clientX);
    //     };

    //     const handleDragOver = (e) => {
    //         e.preventDefault();
    //         const currentX = e.clientX;
    //         const offsetX = currentX - startX;
    //         if (offsetX > 0) {
    //             setDragDirection('right');
    //         } else {
    //             setDragDirection('left');
    //         }
    //     };

    //     const handleDrop = (e) => {
    //         e.preventDefault();
    //         if (dragDirection === 'right') {
    //             slidePrev()
    //         } else if (dragDirection === 'left') {
    //             slideNext()
    //         }
    //         setDragDirection(null);
    //     };

    //     sliderRef.current.addEventListener('dragstart', handleDragStart);
    //     document.addEventListener('dragover', handleDragOver);
    //     document.addEventListener('drop', handleDrop);

    //     return () => {
    //         sliderRef.current.removeEventListener('dragstart', handleDragStart);
    //         document.removeEventListener('dragover', handleDragOver);
    //         document.removeEventListener('drop', handleDrop);
    //     };
    // }, [startX, dragDirection]);

    useEffect(() => {
        const handleDragStart = (e: MouseEvent | TouchEvent) => {
            // e.preventDefault();
            const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
            setStartX(clientX);
        };

        const handleDragMove = (e: MouseEvent | TouchEvent) => {
            if (startX !== null) {
                e.preventDefault();
                const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
                const offsetX = clientX - startX;
                if (offsetX > 0) {
                    setDragDirection('right');
                } else if (offsetX < 0) {
                    setDragDirection('left');
                } else {
                    setDragDirection(null);
                }
            }
        };

        const handleDragEnd = () => {
            if (dragDirection === 'right') {
                slidePrev();
            } else if (dragDirection === 'left') {
                slideNext();
            }
            setStartX(null);
            setDragDirection(null);
        };

        if (sliderRef.current) {
            sliderRef.current.addEventListener('mousedown', handleDragStart);
            sliderRef.current.addEventListener('touchstart', handleDragStart);
            document.addEventListener('mousemove', handleDragMove);
            document.addEventListener('touchmove', handleDragMove);
            document.addEventListener('mouseup', handleDragEnd);
            document.addEventListener('touchend', handleDragEnd);
        }

        return () => {
            if (sliderRef.current) {
                sliderRef.current.removeEventListener('mousedown', handleDragStart);
                sliderRef.current.removeEventListener('touchstart', handleDragStart);
            }
            document.removeEventListener('mousemove', handleDragMove);
            document.removeEventListener('touchmove', handleDragMove);
            document.removeEventListener('mouseup', handleDragEnd);
            document.removeEventListener('touchend', handleDragEnd);
        };
    }, [startX, dragDirection]);

    const usefulMat = page === 'useful-materials'
    const desktop = screenWidth <= 1250
    const pretablet = screenWidth <= 1000
    const tablet = screenWidth <= (usefulMat ? 815 : 700)
    const preMobile = screenWidth <= (usefulMat || page === 'products' ? 676 : 510)
    const mobile = screenWidth <= (usefulMat ? 630 : 480)

    const slidePrev = () => {
        if (translate < 0) {
            setTranslate(translate + marginDifference)
        }
    }

    const slideNext = () => {
        if (translate > (-marginDifference * (list?.length - changeVisibleSlides()))) {
            setTranslate(translate - marginDifference)
        }
    }

    const changeVisibleSlides = () => {
        if (usefulMat) {
            if (mobile) {
                return 1
            }
            if (preMobile) {
                return 2
            }
            if (tablet) {
                return 2
            }
            if (pretablet) {
                return 3
            }
            if (desktop) {
                return 2
            }

            return 3
        }

        if (page === 'products') {
            if (mobile) {
                return 1
            }
            if (preMobile) {
                return 2
            }
        }

        if (page === 'media' || page === 'trading') {
            if (screenWidth <= 900) {
                return 1
            }
            if (pretablet) {
                return 2
            }
            if (desktop) {
                return 1
            }
            return 2
        }

        if (page === 'articles') {
            if (screenWidth <= 1300) {
                return 1
            }
            return 2
        }

        return 4
    }

    const isSlider = () => {
        if (list?.length === changeVisibleSlides() || list?.length < changeVisibleSlides()) {
            return false
        } else {
            return true
        }
    }

    useEffect(() => {
        const updateScreenWidth = () => {
            setScreenWidth(window.innerWidth);
        };

        const defineMarginDifference = () => {
            if (page === 'useful-materials') {
                if (preMobile) {
                    setMarginDifference(272)
                    return
                }
                if (pretablet) {
                    setMarginDifference(258)
                    return
                }

                setMarginDifference(376)
                return
            }
            if (page === 'products') {
                setMarginDifference(274)
                return
            }
            if (page === 'media' || page === 'trading') {
                if (pretablet) {
                    setMarginDifference(274)
                    return
                }
                setMarginDifference(376)
                return
            }
            if (page === 'articles') {
                if (screenWidth <= 676) {
                    setMarginDifference(276)
                    return
                }
                if (screenWidth <= 1000) {
                    setMarginDifference(648)
                    return
                }
                setMarginDifference(658)
                return
            }
        }

        updateScreenWidth();
        defineMarginDifference()

        window.addEventListener('resize', updateScreenWidth);

        return () => {
            window.removeEventListener('resize', updateScreenWidth);
        };
    }, [screenWidth]);

    const [listItem, setList] = useState<any>()

    useEffect(() => {
        if (listItem) {
            if (page === "catalog") {
                if (setHeader) {
                    setHeader([{ title: "Каталог", link: "/catalog" }, { title: `${listItem.title}`, link: "/catalog" }])
                }
            }
        }
    }, [listItem])

    return (
        <div className={`categories-slider__wrapper ${usefulMat && 'useful-materials__categories-slider'}`}>
            <div
                onClick={slidePrev}
                style={translate < 0 ? { opacity: 1, zIndex: 2 } : { opacity: 0, zIndex: -1 }}
                className={`categories-slider__nav categories-slider__nav_prev ${usefulMat && "useful-materials__categories-nav_prev"}`}>
                <Image src={slidePrevArrow} alt='slider-arrow' />
            </div>
            <div
                onClick={slideNext}
                style={translate > (-marginDifference * (list?.length - changeVisibleSlides())) ? { opacity: 1, zIndex: 2 } : { opacity: 0, zIndex: -1 }}
                className={`categories-slider__nav categories-slider__nav_next ${usefulMat && "useful-materials__categories-nav_next"} ${isSlider() && "slider-nav-hidden"}`}>
                <Image src={slideNextArrow} alt='slider-arrow' />
            </div>
            
            <ul draggable ref={sliderRef} style={{ transform: `translateX(${translate}px)` }} className={`categories-slider__list ${usefulMat && "useful-materials__categories-list"}`}>
                {listItem ?
                    listItem.items && listItem.items?.map((item, i) => (
                        page === 'products' ?
                            <UsefulMatCard key={item.id} item={item} />
                            :
                            page === 'media' ?
                                <MegaschoolCard slidePrev={slidePrev} slideNext={slideNext} key={i} item={item} i={i} type={type}/>
                                :
                                page === 'trading' ?
                                    <AssortmentCard item={item} key={i}/>
                                    :
                                    page === 'articles' ?
                                        <OurArticlesCard item={item} key={i}/>
                                        :
                                        <MaterialsCategory key={item.title} item={item} />
                    ))
                    :
                    list && list?.map((item, i) => (
                        page === 'products' ?
                            <UsefulMatCard key={item.id} item={item} />
                            :
                            page === 'media' ?
                                <MegaschoolCard slidePrev={slidePrev} slideNext={slideNext} key={i} item={item} i={i} type={type}/>
                                :
                                page === 'trading' ?
                                    <AssortmentCard item={item} key={i}/>
                                    :
                                    page === 'articles' ?
                                        <OurArticlesCard key={item.id} item={item} />
                                        :
                                        <MaterialsCategory key={item.title} item={item} />
                    ))
                }
            </ul>
        </div>
    )
}

export default CategoriesSlider
